import { useEffect, useRef } from "react"
import { useParams } from 'react-router-dom'
import { useGetHepQuery } from './hepApiSlice'
import { useGetHepExercisesQuery } from "./hepexercisesApiSlice"
import { useGetUsersQuery } from '../users/usersApiSlice'
import useTitle from '../../hooks/useTitle'
import { toast } from 'react-toastify'
import PulseLoader from 'react-spinners/PulseLoader'
import HepExercisePrint from "./HepExercisePrint"
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom"


const PrintHep = () => {

    useTitle('DPE: Print HEP')


    const { id } = useParams()

    const navigate = useNavigate()

    const contentRef = useRef()
    const onPrintButtonClicked = useReactToPrint({ contentRef });

    const onHepButtonClicked = async () => {
        navigate(`/dash/hep/${id}`)
    }

    const onPortalButtonClicked = async () => {
        navigate(`/portal/${id}`)
    }

    const onUploadButtonClicked = async () => {
        navigate(`/dash/upload`)
    }

    const { hep } = useGetHepQuery("hepList", {
        selectFromResult: ({ data }) => ({
            hep: data?.entities[id]
        }),
    })

    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[hep.user]
        }),
    })
    
    const {
        data: hepExercises,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetHepExercisesQuery('hepexercisesList')

    useEffect(() => {

        if (isError) {
            toast.error(error?.data?.message);
        }

    }, [isError, error])

    

    let content
    if (isLoading) content = <PulseLoader color={"#5f788a"} />


    if (isSuccess) {

        const {ids, entities} = hepExercises
        let filteredIds
        filteredIds = ids.filter(hepId => entities[hepId].hep_id === id)

        const tableContent = filteredIds?.length && filteredIds.map(hepId => <HepExercisePrint key={hepId} hepId={hepId} />)

        content = (
        
            <section id="main_content" >
                <main ref={contentRef} id="print_content">
                    <div className="row mt-3">
                        <div className="col-md-12 text-center text-steel">
                            <h4>
                                {user.firstname} {user.lastname} 
                                {(user.clinic) && <span> | {user.clinic}</span>}
                                <br/>
                                {(user.email) && <span>{user.email}</span>} 
                                {(user.phone) && <span> | {user.phone}</span>} 
                            </h4>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12 text-steel"><h1>{hep.title}</h1></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="mt-3 text-steel">Instructions</h4>
                            <p>{hep.text}</p>
                            {tableContent}
                        </div>
                    </div>
                </main>
                <footer>
                    <div className="row">
                        <div className="col-md-12 text-end">
                            <button onClick={() => onUploadButtonClicked()} className="btn btn-steel m-2">Upload HEP</button>
                            <button onClick={() => onHepButtonClicked()} className="btn btn-steel m-2">Edit HEP</button>
                            <button onClick={() => onPrintButtonClicked()} className="btn btn-steel m-2">Print</button>
                            <button onClick={() => onPortalButtonClicked()} className="btn btn-steel m-2">Portal</button>
                        </div>
                    </div>
                </footer>
            </section>
        )
    }
    return content


}

export default PrintHep